// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  urlSearchParamsBodySerializer
} from '@hey-api/client-axios';
import type {
  AddCsvV1CowsAddCsvPostData,
  AddCsvV1CowsAddCsvPostError,
  AddCsvV1CowsAddCsvPostResponse,
  AddNewColV1FarmsAddColDefPostData,
  AddNewColV1FarmsAddColDefPostError,
  AddNewColV1FarmsAddColDefPostResponse,
  AddUserV1UsersPostData,
  AddUserV1UsersPostError,
  AddUserV1UsersPostResponse,
  ChatWithAgentV1AgentChatPostData,
  ChatWithAgentV1AgentChatPostError,
  ChatWithAgentV1AgentChatPostResponse,
  CheckEmailExistsV1AuthExistsEmailPostData,
  CheckEmailExistsV1AuthExistsEmailPostError,
  CheckEmailExistsV1AuthExistsEmailPostResponse,
  CheckUsernameExistsV1AuthExistsUsernamePostData,
  CheckUsernameExistsV1AuthExistsUsernamePostError,
  CheckUsernameExistsV1AuthExistsUsernamePostResponse,
  CreateAddColOptionV1FarmsAddSelectColOptionPostData,
  CreateAddColOptionV1FarmsAddSelectColOptionPostError,
  CreateAddColOptionV1FarmsAddSelectColOptionPostResponse,
  CreateCowV1CowsPostData,
  CreateCowV1CowsPostError,
  CreateCowV1CowsPostResponse,
  CreateFarmV1FarmsPostData,
  CreateFarmV1FarmsPostError,
  CreateFarmV1FarmsPostResponse,
  CreateIronV1FarmsIronsPostData,
  CreateIronV1FarmsIronsPostError,
  CreateIronV1FarmsIronsPostResponse,
  CreateOrUpdateMilkV1MilksPatchData,
  CreateOrUpdateMilkV1MilksPatchError,
  CreateOrUpdateMilkV1MilksPatchResponse,
  CreateRaceV1FarmsRacesPostData,
  CreateRaceV1FarmsRacesPostError,
  CreateRaceV1FarmsRacesPostResponse,
  DeleteAbortionV1CowsAbortionsIdDeleteData,
  DeleteAbortionV1CowsAbortionsIdDeleteError,
  DeleteAbortionV1CowsAbortionsIdDeleteResponse,
  DeleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDeleteData,
  DeleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDeleteError,
  DeleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDeleteResponse,
  DeleteColV1FarmsAddColDefIdDeleteData,
  DeleteColV1FarmsAddColDefIdDeleteError,
  DeleteColV1FarmsAddColDefIdDeleteResponse,
  DeleteCowsV1CowsBulkDeletePostData,
  DeleteCowsV1CowsBulkDeletePostError,
  DeleteCowsV1CowsBulkDeletePostResponse,
  DeleteCowV1CowsIdDeleteData,
  DeleteCowV1CowsIdDeleteError,
  DeleteCowV1CowsIdDeleteResponse,
  DeleteFarmV1FarmsIdAltIdDeleteData,
  DeleteFarmV1FarmsIdAltIdDeleteError,
  DeleteFarmV1FarmsIdAltIdDeleteResponse,
  DeleteHistoryV1HistoryDeleteError,
  DeleteHistoryV1HistoryDeleteResponse,
  DeleteIronV1FarmsIronsIdAltIdDeleteData,
  DeleteIronV1FarmsIronsIdAltIdDeleteError,
  DeleteIronV1FarmsIronsIdAltIdDeleteResponse,
  DeleteMilkV1MilksIdDeleteData,
  DeleteMilkV1MilksIdDeleteError,
  DeleteMilkV1MilksIdDeleteResponse,
  DeleteRaceV1FarmsRacesIdAltIdDeleteData,
  DeleteRaceV1FarmsRacesIdAltIdDeleteError,
  DeleteRaceV1FarmsRacesIdAltIdDeleteResponse,
  DeleteRevisionV1RevisionsFarmIdDateDeleteData,
  DeleteRevisionV1RevisionsFarmIdDateDeleteError,
  DeleteRevisionV1RevisionsFarmIdDateDeleteResponse,
  DeleteUserV1UsersUserIdDeleteData,
  DeleteUserV1UsersUserIdDeleteError,
  DeleteUserV1UsersUserIdDeleteResponse,
  GetAccountV1AccountsIdGetData,
  GetAccountV1AccountsIdGetError,
  GetAccountV1AccountsIdGetResponse,
  GetBabiesV1CowsBabiesMotherIdGetData,
  GetBabiesV1CowsBabiesMotherIdGetError,
  GetBabiesV1CowsBabiesMotherIdGetResponse,
  GetCowIdsAndNumbersV1CowsIdsNumbersGetError,
  GetCowIdsAndNumbersV1CowsIdsNumbersGetResponse,
  GetHealthV1HealthGetError,
  GetHealthV1HealthGetResponse,
  GetResetPasswordTokenV1AuthSendResetPasswordEmailPostData,
  GetResetPasswordTokenV1AuthSendResetPasswordEmailPostError,
  GetResetPasswordTokenV1AuthSendResetPasswordEmailPostResponse,
  GetRevisionsV1RevisionsGetError,
  GetRevisionsV1RevisionsGetResponse,
  GetRevisionV1RevisionsFarmIdDateGetData,
  GetRevisionV1RevisionsFarmIdDateGetError,
  GetRevisionV1RevisionsFarmIdDateGetResponse,
  LoginForAccessTokenV1AuthLoginPostData,
  LoginForAccessTokenV1AuthLoginPostError,
  LoginForAccessTokenV1AuthLoginPostResponse,
  ReadCowsV1CowsGetData,
  ReadCowsV1CowsGetError,
  ReadCowsV1CowsGetResponse,
  ReadCowV1CowsIdGetData,
  ReadCowV1CowsIdGetError,
  ReadCowV1CowsIdGetResponse,
  ReadHistoryV1HistoryGetError,
  ReadHistoryV1HistoryGetResponse,
  ReadMilksV1MilksGetError,
  ReadMilksV1MilksGetResponse,
  ReadUsersMeV1UsersMeGetError,
  ReadUsersMeV1UsersMeGetResponse,
  RefreshTokenV1AuthRefreshTokenGetError,
  RefreshTokenV1AuthRefreshTokenGetResponse,
  ResetPasswordV1AuthResetPasswordPostData,
  ResetPasswordV1AuthResetPasswordPostError,
  ResetPasswordV1AuthResetPasswordPostResponse,
  SavePaymentRouteV1AuthSavePaymentPostData,
  SavePaymentRouteV1AuthSavePaymentPostError,
  SavePaymentRouteV1AuthSavePaymentPostResponse,
  SaveRevisionV1RevisionsFarmIdPostData,
  SaveRevisionV1RevisionsFarmIdPostError,
  SaveRevisionV1RevisionsFarmIdPostResponse,
  SendRegistrationEmailV1AuthRegistratePostData,
  SendRegistrationEmailV1AuthRegistratePostError,
  SendRegistrationEmailV1AuthRegistratePostResponse,
  SetColDefaultV1FarmsColDefaultTypeIdPostData,
  SetColDefaultV1FarmsColDefaultTypeIdPostError,
  SetColDefaultV1FarmsColDefaultTypeIdPostResponse,
  UpdateAddColOptionV1FarmsAddSelectColOptionIdPatchData,
  UpdateAddColOptionV1FarmsAddSelectColOptionIdPatchError,
  UpdateAddColOptionV1FarmsAddSelectColOptionIdPatchResponse,
  UpdateColNameV1FarmsAddColDefIdPatchData,
  UpdateColNameV1FarmsAddColDefIdPatchError,
  UpdateColNameV1FarmsAddColDefIdPatchResponse,
  UpdateCowColValV1CowsIdColValPatchData,
  UpdateCowColValV1CowsIdColValPatchError,
  UpdateCowColValV1CowsIdColValPatchResponse,
  UpdateCowV1CowsIdPatchData,
  UpdateCowV1CowsIdPatchError,
  UpdateCowV1CowsIdPatchResponse,
  UpdateFarmV1FarmsIdPatchData,
  UpdateFarmV1FarmsIdPatchError,
  UpdateFarmV1FarmsIdPatchResponse,
  UpdateIronV1FarmsIronsIdPatchData,
  UpdateIronV1FarmsIronsIdPatchError,
  UpdateIronV1FarmsIronsIdPatchResponse,
  UpdatePasswordV1AuthUpdatePasswordPostData,
  UpdatePasswordV1AuthUpdatePasswordPostError,
  UpdatePasswordV1AuthUpdatePasswordPostResponse,
  UpdateRaceV1FarmsRacesIdPatchData,
  UpdateRaceV1FarmsRacesIdPatchError,
  UpdateRaceV1FarmsRacesIdPatchResponse,
  UpdateSelectedV1CowsFarmIdSelectedPostData,
  UpdateSelectedV1CowsFarmIdSelectedPostError,
  UpdateSelectedV1CowsFarmIdSelectedPostResponse,
  UpdateUsernameV1AuthUpdateUsernamePostData,
  UpdateUsernameV1AuthUpdateUsernamePostError,
  UpdateUsernameV1AuthUpdateUsernamePostResponse,
  UpdateUserV1UsersUserIdPatchData,
  UpdateUserV1UsersUserIdPatchError,
  UpdateUserV1UsersUserIdPatchResponse,
  VerifyRegistrationTokenV1AuthVerifyRegistrationTokenGetData,
  VerifyRegistrationTokenV1AuthVerifyRegistrationTokenGetError,
  VerifyRegistrationTokenV1AuthVerifyRegistrationTokenGetResponse
} from './types.gen';

export const client = createClient(createConfig());

export class HealthService {
  /**
   * Get Health
   */
  public static getHealthV1HealthGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetHealthV1HealthGetResponse,
      GetHealthV1HealthGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/health/'
    });
  }
}

export class AuthService {
  /**
   * Login For Access Token
   */
  public static loginForAccessTokenV1AuthLoginPost<ThrowOnError extends boolean = false>(
    options: Options<LoginForAccessTokenV1AuthLoginPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      LoginForAccessTokenV1AuthLoginPostResponse,
      LoginForAccessTokenV1AuthLoginPostError,
      ThrowOnError
    >({
      ...options,
      ...urlSearchParamsBodySerializer,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options?.headers
      },
      url: '/v1/auth/login'
    });
  }

  /**
   * Refresh Token
   */
  public static refreshTokenV1AuthRefreshTokenGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      RefreshTokenV1AuthRefreshTokenGetResponse,
      RefreshTokenV1AuthRefreshTokenGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/refresh-token'
    });
  }

  /**
   * Send Registration Email
   */
  public static sendRegistrationEmailV1AuthRegistratePost<ThrowOnError extends boolean = false>(
    options: Options<SendRegistrationEmailV1AuthRegistratePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SendRegistrationEmailV1AuthRegistratePostResponse,
      SendRegistrationEmailV1AuthRegistratePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/registrate'
    });
  }

  /**
   * Verify Registration Token
   */
  public static verifyRegistrationTokenV1AuthVerifyRegistrationTokenGet<
    ThrowOnError extends boolean = false
  >(options: Options<VerifyRegistrationTokenV1AuthVerifyRegistrationTokenGetData, ThrowOnError>) {
    return (options?.client ?? client).get<
      VerifyRegistrationTokenV1AuthVerifyRegistrationTokenGetResponse,
      VerifyRegistrationTokenV1AuthVerifyRegistrationTokenGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/verify-registration/{token}'
    });
  }

  /**
   * Check Username Exists
   */
  public static checkUsernameExistsV1AuthExistsUsernamePost<ThrowOnError extends boolean = false>(
    options: Options<CheckUsernameExistsV1AuthExistsUsernamePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CheckUsernameExistsV1AuthExistsUsernamePostResponse,
      CheckUsernameExistsV1AuthExistsUsernamePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/exists/username'
    });
  }

  /**
   * Check Email Exists
   */
  public static checkEmailExistsV1AuthExistsEmailPost<ThrowOnError extends boolean = false>(
    options: Options<CheckEmailExistsV1AuthExistsEmailPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CheckEmailExistsV1AuthExistsEmailPostResponse,
      CheckEmailExistsV1AuthExistsEmailPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/exists/email'
    });
  }

  /**
   * Get Reset Password Token
   */
  public static getResetPasswordTokenV1AuthSendResetPasswordEmailPost<
    ThrowOnError extends boolean = false
  >(options: Options<GetResetPasswordTokenV1AuthSendResetPasswordEmailPostData, ThrowOnError>) {
    return (options?.client ?? client).post<
      GetResetPasswordTokenV1AuthSendResetPasswordEmailPostResponse,
      GetResetPasswordTokenV1AuthSendResetPasswordEmailPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/send-reset-password-email'
    });
  }

  /**
   * Reset Password
   */
  public static resetPasswordV1AuthResetPasswordPost<ThrowOnError extends boolean = false>(
    options: Options<ResetPasswordV1AuthResetPasswordPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ResetPasswordV1AuthResetPasswordPostResponse,
      ResetPasswordV1AuthResetPasswordPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/reset-password'
    });
  }

  /**
   * Update Username
   */
  public static updateUsernameV1AuthUpdateUsernamePost<ThrowOnError extends boolean = false>(
    options: Options<UpdateUsernameV1AuthUpdateUsernamePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      UpdateUsernameV1AuthUpdateUsernamePostResponse,
      UpdateUsernameV1AuthUpdateUsernamePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/update-username'
    });
  }

  /**
   * Update Password
   */
  public static updatePasswordV1AuthUpdatePasswordPost<ThrowOnError extends boolean = false>(
    options: Options<UpdatePasswordV1AuthUpdatePasswordPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      UpdatePasswordV1AuthUpdatePasswordPostResponse,
      UpdatePasswordV1AuthUpdatePasswordPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/update-password'
    });
  }

  /**
   * Save Payment Route
   */
  public static savePaymentRouteV1AuthSavePaymentPost<ThrowOnError extends boolean = false>(
    options: Options<SavePaymentRouteV1AuthSavePaymentPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SavePaymentRouteV1AuthSavePaymentPostResponse,
      SavePaymentRouteV1AuthSavePaymentPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/auth/save-payment'
    });
  }
}

export class CowsService {
  /**
   * Read Cows
   */
  public static readCowsV1CowsGet<ThrowOnError extends boolean = false>(
    options?: Options<ReadCowsV1CowsGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReadCowsV1CowsGetResponse,
      ReadCowsV1CowsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows'
    });
  }

  /**
   * Create Cow
   */
  public static createCowV1CowsPost<ThrowOnError extends boolean = false>(
    options: Options<CreateCowV1CowsPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateCowV1CowsPostResponse,
      CreateCowV1CowsPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows'
    });
  }

  /**
   * Add Csv
   */
  public static addCsvV1CowsAddCsvPost<ThrowOnError extends boolean = false>(
    options: Options<AddCsvV1CowsAddCsvPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddCsvV1CowsAddCsvPostResponse,
      AddCsvV1CowsAddCsvPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/add-csv'
    });
  }

  /**
   * Delete Cows
   */
  public static deleteCowsV1CowsBulkDeletePost<ThrowOnError extends boolean = false>(
    options: Options<DeleteCowsV1CowsBulkDeletePostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      DeleteCowsV1CowsBulkDeletePostResponse,
      DeleteCowsV1CowsBulkDeletePostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/bulk-delete'
    });
  }

  /**
   * Get Cow Ids And Numbers
   */
  public static getCowIdsAndNumbersV1CowsIdsNumbersGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetCowIdsAndNumbersV1CowsIdsNumbersGetResponse,
      GetCowIdsAndNumbersV1CowsIdsNumbersGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/ids-numbers'
    });
  }

  /**
   * Get Babies
   */
  public static getBabiesV1CowsBabiesMotherIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetBabiesV1CowsBabiesMotherIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetBabiesV1CowsBabiesMotherIdGetResponse,
      GetBabiesV1CowsBabiesMotherIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/babies/{mother_id}'
    });
  }

  /**
   * Delete Abortion
   */
  public static deleteAbortionV1CowsAbortionsIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteAbortionV1CowsAbortionsIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteAbortionV1CowsAbortionsIdDeleteResponse,
      DeleteAbortionV1CowsAbortionsIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/abortions/{id}'
    });
  }

  /**
   * Update Selected
   */
  public static updateSelectedV1CowsFarmIdSelectedPost<ThrowOnError extends boolean = false>(
    options: Options<UpdateSelectedV1CowsFarmIdSelectedPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      UpdateSelectedV1CowsFarmIdSelectedPostResponse,
      UpdateSelectedV1CowsFarmIdSelectedPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/{farm_id}/selected'
    });
  }

  /**
   * Read Cow
   */
  public static readCowV1CowsIdGet<ThrowOnError extends boolean = false>(
    options: Options<ReadCowV1CowsIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReadCowV1CowsIdGetResponse,
      ReadCowV1CowsIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/{id}'
    });
  }

  /**
   * Update Cow
   */
  public static updateCowV1CowsIdPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateCowV1CowsIdPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateCowV1CowsIdPatchResponse,
      UpdateCowV1CowsIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/{id}'
    });
  }

  /**
   * Delete Cow
   */
  public static deleteCowV1CowsIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteCowV1CowsIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteCowV1CowsIdDeleteResponse,
      DeleteCowV1CowsIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/{id}'
    });
  }

  /**
   * Update Cow Col Val
   */
  public static updateCowColValV1CowsIdColValPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateCowColValV1CowsIdColValPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateCowColValV1CowsIdColValPatchResponse,
      UpdateCowColValV1CowsIdColValPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/cows/{id}/col-val'
    });
  }
}

export class FarmsService {
  /**
   * Create Farm
   */
  public static createFarmV1FarmsPost<ThrowOnError extends boolean = false>(
    options: Options<CreateFarmV1FarmsPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateFarmV1FarmsPostResponse,
      CreateFarmV1FarmsPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms'
    });
  }

  /**
   * Update Farm
   */
  public static updateFarmV1FarmsIdPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateFarmV1FarmsIdPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateFarmV1FarmsIdPatchResponse,
      UpdateFarmV1FarmsIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/{id}'
    });
  }

  /**
   * Delete Farm
   */
  public static deleteFarmV1FarmsIdAltIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteFarmV1FarmsIdAltIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteFarmV1FarmsIdAltIdDeleteResponse,
      DeleteFarmV1FarmsIdAltIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/{id}/{alt_id}'
    });
  }

  /**
   * Create Iron
   */
  public static createIronV1FarmsIronsPost<ThrowOnError extends boolean = false>(
    options: Options<CreateIronV1FarmsIronsPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateIronV1FarmsIronsPostResponse,
      CreateIronV1FarmsIronsPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/irons'
    });
  }

  /**
   * Update Iron
   */
  public static updateIronV1FarmsIronsIdPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateIronV1FarmsIronsIdPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateIronV1FarmsIronsIdPatchResponse,
      UpdateIronV1FarmsIronsIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/irons/{id}'
    });
  }

  /**
   * Delete Iron
   */
  public static deleteIronV1FarmsIronsIdAltIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteIronV1FarmsIronsIdAltIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteIronV1FarmsIronsIdAltIdDeleteResponse,
      DeleteIronV1FarmsIronsIdAltIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/irons/{id}/{alt_id}'
    });
  }

  /**
   * Create Race
   */
  public static createRaceV1FarmsRacesPost<ThrowOnError extends boolean = false>(
    options: Options<CreateRaceV1FarmsRacesPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      CreateRaceV1FarmsRacesPostResponse,
      CreateRaceV1FarmsRacesPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/races'
    });
  }

  /**
   * Update Race
   */
  public static updateRaceV1FarmsRacesIdPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateRaceV1FarmsRacesIdPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateRaceV1FarmsRacesIdPatchResponse,
      UpdateRaceV1FarmsRacesIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/races/{id}'
    });
  }

  /**
   * Delete Race
   */
  public static deleteRaceV1FarmsRacesIdAltIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteRaceV1FarmsRacesIdAltIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteRaceV1FarmsRacesIdAltIdDeleteResponse,
      DeleteRaceV1FarmsRacesIdAltIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/races/{id}/{alt_id}'
    });
  }

  /**
   * Set Col Default
   */
  public static setColDefaultV1FarmsColDefaultTypeIdPost<ThrowOnError extends boolean = false>(
    options: Options<SetColDefaultV1FarmsColDefaultTypeIdPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SetColDefaultV1FarmsColDefaultTypeIdPostResponse,
      SetColDefaultV1FarmsColDefaultTypeIdPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/col-default/{type}/{id}'
    });
  }

  /**
   * Create Add Col Option
   */
  public static createAddColOptionV1FarmsAddSelectColOptionPost<
    ThrowOnError extends boolean = false
  >(options: Options<CreateAddColOptionV1FarmsAddSelectColOptionPostData, ThrowOnError>) {
    return (options?.client ?? client).post<
      CreateAddColOptionV1FarmsAddSelectColOptionPostResponse,
      CreateAddColOptionV1FarmsAddSelectColOptionPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/add-select-col-option'
    });
  }

  /**
   * Update Add Col Option
   */
  public static updateAddColOptionV1FarmsAddSelectColOptionIdPatch<
    ThrowOnError extends boolean = false
  >(options: Options<UpdateAddColOptionV1FarmsAddSelectColOptionIdPatchData, ThrowOnError>) {
    return (options?.client ?? client).patch<
      UpdateAddColOptionV1FarmsAddSelectColOptionIdPatchResponse,
      UpdateAddColOptionV1FarmsAddSelectColOptionIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/add-select-col-option/{id}'
    });
  }

  /**
   * Delete Add Col Option
   */
  public static deleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDelete<
    ThrowOnError extends boolean = false
  >(options: Options<DeleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDeleteData, ThrowOnError>) {
    return (options?.client ?? client).delete<
      DeleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDeleteResponse,
      DeleteAddColOptionV1FarmsAddSelectColOptionIdAltIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/add-select-col-option/{id}/{alt_id}'
    });
  }

  /**
   * Add New Col
   */
  public static addNewColV1FarmsAddColDefPost<ThrowOnError extends boolean = false>(
    options: Options<AddNewColV1FarmsAddColDefPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddNewColV1FarmsAddColDefPostResponse,
      AddNewColV1FarmsAddColDefPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/add-col-def'
    });
  }

  /**
   * Update Col Name
   */
  public static updateColNameV1FarmsAddColDefIdPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateColNameV1FarmsAddColDefIdPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateColNameV1FarmsAddColDefIdPatchResponse,
      UpdateColNameV1FarmsAddColDefIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/add-col-def/{id}'
    });
  }

  /**
   * Delete Col
   */
  public static deleteColV1FarmsAddColDefIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteColV1FarmsAddColDefIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteColV1FarmsAddColDefIdDeleteResponse,
      DeleteColV1FarmsAddColDefIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/farms/add-col-def/{id}'
    });
  }
}

export class MilksService {
  /**
   * Read Milks
   */
  public static readMilksV1MilksGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReadMilksV1MilksGetResponse,
      ReadMilksV1MilksGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/milks'
    });
  }

  /**
   * Create Or Update Milk
   */
  public static createOrUpdateMilkV1MilksPatch<ThrowOnError extends boolean = false>(
    options: Options<CreateOrUpdateMilkV1MilksPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      CreateOrUpdateMilkV1MilksPatchResponse,
      CreateOrUpdateMilkV1MilksPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/milks'
    });
  }

  /**
   * Delete Milk
   */
  public static deleteMilkV1MilksIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteMilkV1MilksIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteMilkV1MilksIdDeleteResponse,
      DeleteMilkV1MilksIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/milks/{id}'
    });
  }
}

export class HistoryService {
  /**
   * Read History
   */
  public static readHistoryV1HistoryGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReadHistoryV1HistoryGetResponse,
      ReadHistoryV1HistoryGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/history'
    });
  }

  /**
   * Delete History
   */
  public static deleteHistoryV1HistoryDelete<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteHistoryV1HistoryDeleteResponse,
      DeleteHistoryV1HistoryDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/history'
    });
  }
}

export class RevisionsService {
  /**
   * Save Revision
   */
  public static saveRevisionV1RevisionsFarmIdPost<ThrowOnError extends boolean = false>(
    options: Options<SaveRevisionV1RevisionsFarmIdPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      SaveRevisionV1RevisionsFarmIdPostResponse,
      SaveRevisionV1RevisionsFarmIdPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/revisions/{farm_id}'
    });
  }

  /**
   * Get Revisions
   */
  public static getRevisionsV1RevisionsGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetRevisionsV1RevisionsGetResponse,
      GetRevisionsV1RevisionsGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/revisions'
    });
  }

  /**
   * Get Revision
   */
  public static getRevisionV1RevisionsFarmIdDateGet<ThrowOnError extends boolean = false>(
    options: Options<GetRevisionV1RevisionsFarmIdDateGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetRevisionV1RevisionsFarmIdDateGetResponse,
      GetRevisionV1RevisionsFarmIdDateGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/revisions/{farm_id}/{date}'
    });
  }

  /**
   * Delete Revision
   */
  public static deleteRevisionV1RevisionsFarmIdDateDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteRevisionV1RevisionsFarmIdDateDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteRevisionV1RevisionsFarmIdDateDeleteResponse,
      DeleteRevisionV1RevisionsFarmIdDateDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/revisions/{farm_id}/{date}'
    });
  }
}

export class UsersService {
  /**
   * Read Users Me
   */
  public static readUsersMeV1UsersMeGet<ThrowOnError extends boolean = false>(
    options?: Options<unknown, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      ReadUsersMeV1UsersMeGetResponse,
      ReadUsersMeV1UsersMeGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/users/me'
    });
  }

  /**
   * Add User
   */
  public static addUserV1UsersPost<ThrowOnError extends boolean = false>(
    options: Options<AddUserV1UsersPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      AddUserV1UsersPostResponse,
      AddUserV1UsersPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/users'
    });
  }

  /**
   * Delete User
   */
  public static deleteUserV1UsersUserIdDelete<ThrowOnError extends boolean = false>(
    options: Options<DeleteUserV1UsersUserIdDeleteData, ThrowOnError>
  ) {
    return (options?.client ?? client).delete<
      DeleteUserV1UsersUserIdDeleteResponse,
      DeleteUserV1UsersUserIdDeleteError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/users/{user_id}'
    });
  }

  /**
   * Update User
   */
  public static updateUserV1UsersUserIdPatch<ThrowOnError extends boolean = false>(
    options: Options<UpdateUserV1UsersUserIdPatchData, ThrowOnError>
  ) {
    return (options?.client ?? client).patch<
      UpdateUserV1UsersUserIdPatchResponse,
      UpdateUserV1UsersUserIdPatchError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/users/{user_id}'
    });
  }
}

export class AccountsService {
  /**
   * Get Account
   */
  public static getAccountV1AccountsIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetAccountV1AccountsIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetAccountV1AccountsIdGetResponse,
      GetAccountV1AccountsIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/accounts/{id}'
    });
  }
}

export class AgentService {
  /**
   * Chat With Agent
   */
  public static chatWithAgentV1AgentChatPost<ThrowOnError extends boolean = false>(
    options: Options<ChatWithAgentV1AgentChatPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ChatWithAgentV1AgentChatPostResponse,
      ChatWithAgentV1AgentChatPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/agent/chat'
    });
  }
}
